import router from './index';

// States
import activeSessions from '../modules/active-sessions/state';
import fourofour from '../modules/404/state';
import integration from '../modules/integration/state';
import login from '../modules/login/state';
import ssoComplete from '../modules/sso-complete/state';
import SelectProfile from '../modules/select-profile/state';
import account from '../modules/account/state';
import logout from '../modules/logout/state';
import holding from '../modules/holding/state';

/* ====================
	
	!! IMPORTANT !!

	You must also add any new url directories to the "paths" 
	array in /scripts/make-static-paths.js

==================== */
const states = [
    activeSessions,
    fourofour,
    integration,
    login,
    ssoComplete,
    SelectProfile,
    account,
    logout,
    holding,
];

// Register states
states.forEach(state => router.stateRegistry.register(state));

export default router;